import React from 'react'
import styles from './Result.module.css'
import styles2 from './s.module.css'

class Result extends React.Component {
  render () {
    return (
      <div className={styles2.dimItemContainer}>
        <label>{this.props.label}</label>
        <div className={styles.result} >{this.props.value}</div>
      </div>
    )
  }
}

// Result.propTypes = {
//   label: PropTypes.string,
//   value: PropTypes.string
// }

export default Result
